// hooks/useIdleTimer.ts
import { useEffect, useRef } from 'react';

const useIdleTimer = ({
  onIdle,
  timeout = 2 * 60 * 60 * 1000, // 2 hours
  tokenKey = localStorage.getItem("access_token") || "",
}: {
  onIdle: () => void;
  timeout?: number;
  tokenKey?: string;
}) => {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const resetTimer = () => {
    if (!localStorage.getItem(tokenKey)) return; // Don't run timer if user is not logged in
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      if (localStorage.getItem(tokenKey)) {
        onIdle(); // Auto logout
      }
    }, timeout);
  };

  useEffect(() => {
    const events = ['mousemove', 'mousedown', 'keypress', 'touchstart', 'scroll'];
    events.forEach(event => window.addEventListener(event, resetTimer));

    resetTimer(); // Initialize on mount

    return () => {
      events.forEach(event => window.removeEventListener(event, resetTimer));
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);
};

export default useIdleTimer;
